"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MultiCompanyGlobalSearch;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const ThemeContext_1 = require("../ThemeContext");
const react_i18next_1 = require("react-i18next");
const UserContext_1 = require("../contexts/UserContext");
const cancelable_promise_1 = require("cancelable-promise");
const MyProfile_1 = __importDefault(require("../api/MyProfile"));
const SearchableInput_shared_1 = require("../components/SearchableInput.shared");
const SearchableInput_1 = require("../components/SearchableInput");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const Theme_1 = require("../Theme");
const ExpandableSearchBar_1 = __importDefault(require("../components/ExpandableSearchBar"));
const Helper_1 = require("../Helper");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const react_native_paper_1 = require("react-native-paper");
const OverlayContext_1 = require("../contexts/OverlayContext");
const ModalWrapper_1 = __importDefault(require("../components/ModalWrapper"));
const Button_1 = __importDefault(require("../components/Button"));
const AdminContext_1 = require("../contexts/AdminContext");
const getStatusLabel = (statusClass) => {
    switch (statusClass) {
        case 'A': return 'Active';
        case 'L': return 'On Leave';
        case 'P': return 'New Hire';
        case 'T': return 'Terminated';
        default: return statusClass ?? '';
    }
};
const getStatusBackground = (statusClass, THEME) => {
    switch (statusClass) {
        case 'Active': return `${THEME.Secondary}66`;
        case 'Terminated': return `${THEME.Red}66`;
        case 'New Hire': return `${THEME.CardBorder}AA`;
        case 'On Leave': return `${THEME.Warning}66`;
        default: return 'transparent';
    }
};
const useStyles = (THEME, isDarkMode) => {
    return react_native_1.StyleSheet.create({
        sectionHeader: {
            gap: 8,
            flexDirection: 'row',
            alignItems: 'center',
            backgroundColor: isDarkMode ? THEME.SmokeWhite : `${THEME.Gray}55`,
            borderTopRightRadius: 4,
            borderTopLeftRadius: 4,
            height: 32,
            paddingHorizontal: 12,
            marginTop: 4,
        },
        sectionTitle: { fontSize: 12, fontWeight: '600', color: THEME.Text },
        itemRow: {
            paddingHorizontal: 1,
            paddingVertical: 3,
            justifyContent: 'space-between',
            flexDirection: 'row',
            alignItems: 'center',
            backgroundColor: isDarkMode ? `${THEME.SoftGray}AA` : THEME.OffWhite,
        },
        employeeName: { fontSize: 13, color: THEME.Text, fontWeight: '400' },
        employeeRole: { fontSize: 12, color: THEME.TextLight, marginTop: 1, opacity: 0.8 },
        emptyText: { textAlign: 'center', color: THEME.Text, fontSize: 12, padding: 32 },
    });
};
function SearchResultsList({ inputRef }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const isDarkMode = (0, ThemeContext_1.useIsDark)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const styles = useStyles(THEME, isDarkMode);
    const { displayList, loading, searchText, setSearchText, setIsOpen, pinnedItemIndices } = (0, SearchableInput_shared_1.useSearchable)();
    const activeBorderColor = isDarkMode ? THEME.Secondary : THEME.Primary;
    const borderColor = isDarkMode ? THEME.SecondaryLight : THEME.PrimaryLight;
    const handleClose = (0, react_1.useCallback)(() => {
        setSearchText('');
        setIsOpen(false);
    }, [setSearchText, setIsOpen]);
    const renderItem = (0, react_1.useCallback)(({ item }) => {
        const statusBg = getStatusBackground(item.employeeStatusClass, THEME);
        return ((0, jsx_runtime_1.jsx)(SearchableInput_1.SearchableInput.Item, { item: item, style: item.isHeader ? {} : {
                justifyContent: 'space-between',
                flexDirection: 'row',
                alignItems: 'center',
                backgroundColor: THEME.PrimaryBackgroundLight,
            }, "aria-label": item.isHeader ? `${item.groupTitle}, ${item.rawCount}}` : `${item.employeeFullName}, ${item.employeeStatusClass ? item.employeeStatusClass + ',' : ''} ${item.employeeJobTitle ? item.employeeJobTitle + ',' : ''} ${item.groupTitle}}`, children: item.isHeader ? ((0, jsx_runtime_1.jsxs)(react_native_1.Text, { style: { fontSize: 12, fontWeight: '600', color: THEME.Text }, children: [item.groupTitle, " (", item.rawCount, ")"] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flexDirection: 'row', alignItems: 'center', gap: 8, flex: 1, padding: 4, borderLeftColor: statusBg, borderLeftWidth: 4 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: [styles.employeeName, { color: THEME.Text, fontWeight: '500', paddingLeft: 4 }], numberOfLines: 1, children: item.employeeFullName }) }), item.employeeJobTitle && ((0, jsx_runtime_1.jsx)(react_native_1.Text, { style: [styles.employeeRole, { color: THEME.Text }], children: item.employeeJobTitle }))] })) }));
    }, [isDarkMode, THEME]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!(Helper_1.Helper.isPlatformWeb && size !== 'sm') && ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', alignItems: 'center', paddingBottom: 15, gap: 8 }, children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { ref: inputRef, value: searchText, placeholder: t('profile:text.searchEmployees'), onChangeText: (text) => {
                            setSearchText(text);
                        }, mode: "outlined", dense: true, theme: {
                            roundness: 40,
                            colors: {
                                background: THEME.PrimaryBackgroundLight,
                            },
                        }, outlineColor: borderColor, activeOutlineColor: activeBorderColor, lineBreakModeIOS: 'tail', style: {
                            flex: 1,
                        }, left: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput.Icon, { role: "presentation", tabIndex: -1, style: { pointerEvents: 'none' }, icon: () => {
                                return (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.MagnifyingGlass, color: isDarkMode ? THEME.AlwaysWhite : THEME.Primary });
                            } }), right: searchText.length > 0 ?
                            (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput.Icon, { role: "button", "aria-label": t('common:hints.clearSearch'), icon: () => {
                                    return (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.CircleXmark, size: 20, color: isDarkMode ? THEME.AlwaysWhite : THEME.Primary });
                                }, onPress: () => setSearchText('') })
                            : undefined }), (0, jsx_runtime_1.jsx)(Button_1.default, { type: 'borderless', text: t('common:buttons.cancel'), "aria-label": t('common:hints.cancelEmployeeSelection'), onPress: handleClose })] })), loading ? ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, padding: 50, alignItems: 'center', justifyContent: 'center' }, children: (0, jsx_runtime_1.jsx)(react_native_1.ActivityIndicator, { color: THEME.Primary, size: 'large' }) })) : ((0, jsx_runtime_1.jsx)(react_native_1.FlatList, { nestedScrollEnabled: true, showsVerticalScrollIndicator: true, persistentScrollbar: true, overScrollMode: "never", stickyHeaderIndices: pinnedItemIndices, ItemSeparatorComponent: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { height: 2, backgroundColor: THEME.PrimaryBackground } }), contentContainerStyle: { borderRadius: 4 }, data: displayList, keyExtractor: (item) => item.isHeader ? `header-${item.groupKey}` : `item-${item.groupKey}-${item.employeeId}`, renderItem: renderItem, keyboardShouldPersistTaps: "handled", initialNumToRender: 15, maxToRenderPerBatch: 15, windowSize: 5, ListEmptyComponent: (0, jsx_runtime_1.jsxs)(SearchableInput_1.SearchableInput.Empty, { style: {
                        padding: 32,
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 8,
                    }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: searchText ? Theme_1.ICONS.DuoTone.FolderXmark : Theme_1.ICONS.DuoTone.FolderMagnifyingGlass, size: 64, color: THEME.TextLight }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: {
                                textAlign: 'center',
                                fontSize: 14,
                                color: THEME.TextLight,
                            }, children: searchText ? t('common:text.noResults') : t('common:text.startTypingToSearch') })] }) }, pinnedItemIndices.length > 0
                ? `flatlist-pinned-${pinnedItemIndices.join('-')}`
                : (react_native_1.Platform.OS === 'android' ? `flatlist-search-${searchText}` : 'flatlist-search-static')))] }));
}
function MultiCompanyGlobalSearch(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const promise = react_1.default.useRef(null);
    const [data, setData] = react_1.default.useState([]);
    const [status, setStatus] = react_1.default.useState('loading');
    const adminContext = react_1.default.useContext(AdminContext_1.AdminContext);
    const inputRef = react_1.default.useRef(null);
    const handleModalShow = react_1.default.useCallback(() => {
        setTimeout(() => {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    inputRef.current?.focus();
                });
            });
        }, 0);
    }, []);
    const refresh = react_1.default.useCallback(() => {
        promise.current?.cancel();
        setStatus('loading');
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then(async (token) => {
            return await MyProfile_1.default.getClientsWithEmployees(token);
        })).then((response) => {
            const rawData = response ?? [];
            const formattedData = rawData.map((item) => ({
                ...item,
                employeeStatusClass: getStatusLabel(item.employeeStatusClass),
            }));
            setData(formattedData);
            setStatus('done');
        }).catch(e => {
            setStatus((e === 404) ? 'done' : 'error');
        });
    }, []);
    react_1.default.useEffect(() => {
        refresh();
        return () => promise.current?.cancel();
    }, []);
    const handleSelect = react_1.default.useCallback(async (value, item) => {
        console.info("ClientId: ", item?.clientId);
        if (item?.clientId) {
            adminContext?.setEmployeeMenu(null);
            if (item.clientId !== userContext.client?.id) {
                (0, OverlayContext_1.emitToast)({
                    title: t('common:text.headsUp'),
                    message: t('common:text.youveSwitchedCompanies'),
                    type: 'success',
                    duration: 3000,
                });
            }
            await userContext.selectClient(item.clientId, {
                screen: "CompanyEmployeeDetail",
                params: { employeeId: value },
            });
        }
    }, [userContext.client?.id, userContext.selectClient, adminContext, t, props]);
    const isDesktopWeb = Helper_1.Helper.isPlatformWeb && size !== 'sm';
    return ((0, jsx_runtime_1.jsxs)(SearchableInput_1.SearchableInput, { activeColor: 'secondary', backgroundColor: isDesktopWeb ? THEME.PrimaryBackgroundLight : THEME.Background, list: data, loading: status === 'loading', valueKey: "employeeId", labelKey: "employeeFullName", searchFields: ['employeeFullName', 'employeeStatusClass', 'employeeJobTitle', 'clientName'], groupBy: "clientId", groupTitleKey: "clientName", collapsibleSections: true, onSelect: handleSelect, 
        //@ts-ignore // only used in web version
        floatingEnabled: isDesktopWeb, closeWhenTextCleared: true, children: [(0, jsx_runtime_1.jsx)(SearchableInput_1.SearchableInput.Header, { children: (0, jsx_runtime_1.jsx)(ExpandableSearchBar_1.default, { closeSidebar: true, maxWidth: 400, placeholder: t('profile:text.searchEmployees') }) }), (0, jsx_runtime_1.jsx)(SearchableInput_1.SearchableInput.Content, { mobileWrapper: ModalWrapper_1.default, onShow: handleModalShow, children: (0, jsx_runtime_1.jsx)(SearchResultsList, { inputRef: inputRef }) })] }));
}
